<template lang="pug">	
	DxContextMenu(ref="menu", :items="[{ template: 'custom' }]", :target="target", :cssClass="`app-core--context-menu no-padding ${cssClass}`",
		:hoverStateEnabled="false", :onShowing="onShowing", :showEvent="showEvent || 'dxcontextmenu'")
		template(v-slot:custom)
			.content
				.app-core--context-menu(v-if="isContextMenuVisible")
					.level(v-for="level in levels.filter(f => f.item)", :key="level.id", :ref="`level_${level.id}`", :style="{ '--offsetLeft': `${level.offsetLeft || 0}px`, '--offsetTop': `${level.offsetTop || 0}px` }", :class="{ 'sub-level': level.levelIndex > 0 }")
						DxScrollView(:ref="`scrollView_${level.id}`", direction="vertical", showScrollbar="always")
							.scroll-view
								.flex-col
									.item(v-for="item in level.item.items", @click.stop="e => onItemClick(e, item, level, true)", @mouseover="e => onItemClick(e, item, level)")
										template(v-if="$scopedSlots[item.data.template]")
											slot(:name="item.data.template", :data="item.data")
										tempalte(v-else-if="$scopedSlots.item")
											slot(name="item", :data="item.data")
										template(v-else)
											.item-slot.flex-row.justify.space.align-center
												span {{item.data.text}}
												.right
													fas(v-if="item.items && item.items.length", icon="chevron-right", size="xs")
</template>

<script>
import DxScrollView from 'devextreme-vue/scroll-view';
import DxContextMenu from 'devextreme-vue/context-menu';

export default {
	model: {
		
	},
	components: { DxScrollView, DxContextMenu },
	props: ['items', 'target', 'cssClass', 'showEvent'],
	data() {
		return {
			levels: [],
			isContextMenuVisible: false
		}
	},
	computed: {
		allItems() {
			const result = [{
				id: 'root',
				items: this.itemsWithIds
			}];
			const addItems = (items) => {
				result.push(...items);
				items.map(f => addItems(f.items || []));
			}
			addItems(this.itemsWithIds);
			return result;
		},
		itemsWithIds() {
			const processItems = (items, parentId) => {
				return items.map((f, idx) => {
					const item = {
						id: `${parentId ? `${parentId}.` : ''}${idx + 1}`,
						parent: parentId,
						idx,
						data: f,
					};
					item.items = processItems(f.items || [], item.id);
					return item;
				});
			}
			return processItems(this.items);
		},
		rootItemsLength() {
			return this.itemsWithIds.length;
		}
	},
	watch: {
		rootItemsLength() {
			this.refresh(true);
		},
		itemsWithIds: {
			handler() {
				this.refresh()
			},
			deep: true
		}
	},
	mounted() {
		this.refresh(true);
	},
	destroyed() {
		this.refresh(true);
	},
	methods: {
		refresh(clear) {
			if (clear) {
				this.isContextMenuVisible = false;
				this.$nextTick(() => {
					this.isContextMenuVisible = true;
					this.levels = [];
					this.addLevel({
						id: 'root',
						items: this.itemsWithIds
					}, null, this.itemsWithIds);
				});
			} else {
				this.levels.map(f => {
					this.$nextTick(() => {
						this.fixPositions(f);
					});
				});
			}
		},
		onShowing() {
			this.refresh();
		},
		show() {
			if (this.$refs.menu?.instance)
				this.$refs.menu.instance.show();
		},
		hide() {
			if (this.$refs.menu?.instance)
				this.$refs.menu.instance.hide();
			this.refresh(true);
		},
		addLevel(item, initiatorLevel, items, info) {
			if (__DEBUG__)
				window.contextMenu = this;
			const initiatorEl = initiatorLevel && this.$refs[`level_${initiatorLevel.id}`] && this.$refs[`level_${initiatorLevel.id}`][0];			

			if (initiatorLevel) {
				this.levels = this.levels.filter(f => f.levelIndex <= initiatorLevel.levelIndex || f.item === item);
			}

			if (!items?.length) return;

			let level = this.levels.some(f => f.item === item);
			if (!level) {
				level = {
					id: this.$Data.uuid(),
					levelIndex: (initiatorLevel?.levelIndex + 1) || 0,
					initiator: initiatorLevel,
					itemId: item?.id,
					offsetLeft: initiatorEl ? (initiatorEl.offsetWidth + initiatorEl.offsetLeft) : 0,
					...(info || {})
				};

				Object.defineProperty(level, 'item', {
					get: () => this.allItems.find(f => f.id === level.itemId)
				});

				this.levels.push(level);

				if (__DEBUG__)
					console.debug('Add level', { initiatorLevel, items, level, initiatorEl });
			}
			this.$nextTick(() => {
				this.fixPositions(level);
			});
		},
		onItemClick(e, item, level, isClick) {
			this.addLevel(item, level, item.items || [], { parentElem: e.srcElement });

			if (isClick) {
				if (__DEBUG__)
					console.debug('On item click', { e, item, level });
				this.$emit('item-click', { itemData: item.data });
				if (!item?.data?.preventClose)
					this.hide();
			}
		},
		fixPositions(level) {
			const levelEl = level && this.$refs[`level_${level.id}`] && this.$refs[`level_${level.id}`][0];
			if (!levelEl) return;

			const levelBounds = levelEl.getBoundingClientRect();
			const initiatorEl = level.initiator && this.$refs[`level_${level.initiator.id}`] && this.$refs[`level_${level.initiator.id}`][0];
			const initiatorBounds = initiatorEl && initiatorEl.getBoundingClientRect();

			/* Fix left offset */
			if (levelBounds.x + levelBounds.width > window.innerWidth) {
				if (!level.parentElem || !level.initiator || !initiatorEl) {
					level.offsetLeft -=  (levelBounds.x + levelBounds.width) - window.innerWidth;
				} else {
					level.offsetLeft -= (initiatorEl.offsetWidth + levelEl.offsetWidth);
				}
			}

			/* Fix top offset */
			if (!level.parentElem || !level.initiator) {
				if (levelBounds.y + levelBounds.height > window.innerHeight) {
					let offset = (level.offsetTop || 0) + window.innerHeight - (levelBounds.y + levelBounds.height);
					this.$set(level, 'offsetTop', offset);
				}
			} else {
				const elemBounds = level.parentElem.getBoundingClientRect();
				let offsetTop = (elemBounds.y - initiatorBounds.y) + (level.initiator.offsetTop || 0);
				if (levelBounds.y + levelBounds.height + offsetTop > window.innerHeight) {
					offsetTop += window.innerHeight - (levelBounds.y + levelBounds.height + offsetTop);
				}
				this.$set(level, 'offsetTop', offsetTop);
			}

			this.$nextTick(() => {
				this.refreshScroll(this.$refs[`scrollView_${level.id}`][0].instance);
			});
		},
		refreshScroll(scroll) {
			if (scroll)
				scroll.scrollBy(1);
			this.$nextTick(() => {
				if (this._isDestroyed) return;
				scroll.scrollBy(-1);
			});
		}
	}
};
</script>
<style lang="scss">
	.app-core--context-menu {
		position: relative;

		.scroll-view {
			max-height: 50vh;
		}

		.level {
			position: absolute;
			background: #fff;
			border-radius: 4px;
			min-width: 100px;
			border: 1px solid #dedede;
			box-shadow: 0 1px 3px rgba(0,0,0,0.1);
			left: var(--offsetLeft);
			top: var(--offsetTop);

			&.sub-level {
				//transform: translateY(-50%);
			}

			.item {
				.item-slot {
					padding: 4px 8px;
					font-size: 12px;
				}

				&:hover {
					background: #f3f3f3;
				}
			}
		}

		&.no-padding {
			&.dx-context-menu .dx-menu-item .dx-menu-item-content {
				padding: 0px !important;
			}

			.dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-both > .dx-scrollable-wrapper > .dx-scrollable-container > .dx-scrollable-content, 
			.dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-vertical > .dx-scrollable-wrapper > .dx-scrollable-container > .dx-scrollable-content {
				padding-right: 0px !important;
			}
		}
	}
</style>
